import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $941d1d9a6a28982a$var$Cell(props) {
  return null;
}

$941d1d9a6a28982a$var$Cell.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var children, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        children = props.children;
        textValue = props.textValue || (typeof children === 'string' ? children : '') || props['aria-label'] || '';
        _context.next = 4;
        return {
          type: 'cell',
          props: props,
          rendered: children,
          textValue: textValue,
          'aria-label': props['aria-label'],
          hasChildNodes: false
        };

      case 4:
      case "end":
        return _context.stop();
    }
  }, getCollectionNode);
});
/**
 * A Cell represents the value of a single Column within a Table Row.
 */
// We don't want getCollectionNode to show up in the type definition

var $941d1d9a6a28982a$export$f6f0c3fe4ec306ea = $941d1d9a6a28982a$var$Cell;
export { $941d1d9a6a28982a$export$f6f0c3fe4ec306ea as Cell };